"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeWrapper = exports.Root = exports.Name = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  height: 14,
  overflow: 'hidden'
}));
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  boxOrient: 'vertical',
  display: '-webkit-box',
  lineClamp: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1
}));
const ShadeWrapper = exports.ShadeWrapper = (0, _mui.styled)('div')({
  flexShrink: 0
});
//# sourceMappingURL=styles.js.map